export default __webpack_public_path__ + "static/media/38.f7131c01.png";